import { supabase } from "../supabaseClient";

export const SIGNUP_SHEET_IMPORT_COLUMNS =
  "id, tournamentID, squadID, eventID, organizationID, storagePath, fileName, mimeType, eventName, teamSize, extraction, consumedKeys, status, createdAt";

export const sheetFromSignupImport = (row) => {
  if (!row) return null;
  return {
    importId: row.id,
    tournamentId: row.tournamentID,
    squadId: row.squadID,
    eventId: row.eventID,
    organizationID: row.organizationID,
    storagePath: row.storagePath,
    fileName: row.fileName,
    mimeType: row.mimeType,
    eventName: row.eventName,
    teamSize: row.teamSize,
    extraction: row.extraction,
    consumedKeys: row.consumedKeys || [],
    status: row.status,
    createdAt: row.createdAt,
  };
};

const uniqueKeys = (keys) =>
  Array.from(new Set((keys || []).filter((key) => String(key || "").trim())));

export const isMissingSignupImportsTable = (error) => {
  const message = String(error?.message || error?.details || "");
  return (
    error?.code === "42P01" ||
    error?.code === "PGRST205" ||
    /signupSheetImports/i.test(message)
  );
};

export const listPendingSignupSheetImports = async (tournamentId) => {
  if (!tournamentId) return [];
  const { data, error } = await supabase
    .from("signupSheetImports")
    .select(SIGNUP_SHEET_IMPORT_COLUMNS)
    .eq("tournamentID", tournamentId)
    .eq("status", "pending")
    .order("createdAt", { ascending: true });

  if (error) {
    if (isMissingSignupImportsTable(error)) return [];
    throw error;
  }
  return (data || []).map(sheetFromSignupImport);
};

export const saveSignupSheetImport = async ({
  organizationID,
  tournamentId,
  squadId,
  eventId,
  eventName,
  teamSize,
  storagePath,
  fileName,
  mimeType,
  extraction,
  createdBy,
}) => {
  const { data, error } = await supabase
    .from("signupSheetImports")
    .insert({
      organizationID,
      tournamentID: tournamentId,
      squadID: squadId,
      eventID: eventId,
      eventName: eventName || null,
      teamSize: Math.max(1, Number(teamSize) || 1),
      storagePath,
      fileName: fileName || null,
      mimeType: mimeType || null,
      extraction: extraction || {},
      createdBy: createdBy || null,
    })
    .select(SIGNUP_SHEET_IMPORT_COLUMNS)
    .single();

  if (error) throw error;
  return sheetFromSignupImport(data);
};

export const consumeSignupReviewKey = async (
  importId,
  entryKey,
  { completed = false } = {}
) => {
  if (!importId || !entryKey) return null;
  const { data: current, error: loadError } = await supabase
    .from("signupSheetImports")
    .select("consumedKeys")
    .eq("id", importId)
    .single();
  if (loadError) throw loadError;

  const consumedKeys = uniqueKeys([...(current?.consumedKeys || []), entryKey]);
  const { data, error } = await supabase
    .from("signupSheetImports")
    .update({
      consumedKeys,
      status: completed ? "completed" : "pending",
      updatedAt: new Date().toISOString(),
    })
    .eq("id", importId)
    .select(SIGNUP_SHEET_IMPORT_COLUMNS)
    .single();

  if (error) throw error;
  return sheetFromSignupImport(data);
};
